module.exports = __webpack_public_path__ + "static/algorand-mantle-animation-tablet-portrait_algorand-home-bfd2d564f5edf9ba95305f74b55daec9.mp4";